import * as React from 'react'

export const CustomerServiceHeadset = () => {
	return (
		<svg width="100%" height="100%" viewBox="0 0 241 300" xmlns="http://www.w3.org/2000/svg">
			<title>{'9BF5A0A4-AAC6-40B9-83C5-F4414D9DD2E5'}</title>
			<g
				style={{
					mixBlendMode: 'overlay',
				}}
				fill="current"
				fillRule="nonzero"
				opacity={1}
			>
				<path d="M168.773 178H72.21C31.717 181.737 0 216.13 0 258.021 0 298.035 28.937 300 66.833 300c4.136 0 8.374-.02 12.709-.02h81.92c4.304 0 8.553.02 12.688.02 37.897 0 66.85-1.961 66.85-41.979-.013-41.894-31.734-76.29-72.227-80.021zM135.104 137.106h12.155c4.006 0 7.816 1.36 10.885 3.784 6.995-.936 13.601-2.752 19.327-5.225 1.652-2.443 3.088-5.039 4.412-7.697V101.41A23.472 23.472 0 01188 85.55C182.331 53.424 154.304 29 120.498 29 86.703 29 58.668 53.427 53 85.554a23.474 23.474 0 016.117 15.856v26.558C70.358 150.492 93.588 166 120.495 166c.419 0 .825-.053 1.24-.063-2.596-3.064-4.226-6.967-4.226-11.282.004-9.676 7.897-17.55 17.595-17.55z" />
				<path d="M33.407 148.287h.775c8.505 0 15.407-6.863 15.407-15.35V102.32c0-6.015-3.492-11.197-8.572-13.708C43.213 47.178 77.797 14.149 120 14.149s76.8 33.026 78.99 74.462c-5.08 2.507-8.569 7.693-8.569 13.708v30.619c0 2.034.4 3.928 1.097 5.702-8.985 6.379-22.054 10.934-36.773 12.195-1.667-2.518-4.508-4.202-7.754-4.202H134.73c-5.112 0-9.243 4.115-9.243 9.177 0 5.068 4.128 9.19 9.243 9.19h12.26c3.572 0 6.618-2.024 8.154-4.959 17.09-1.34 31.95-6.529 42.39-14.202a15.243 15.243 0 008.291 2.445h.771c8.515 0 15.404-6.863 15.404-15.35v-30.618c0-6.1-3.595-11.364-8.783-13.809C210.957 39.342 170.014 0 120.003 0 69.993 0 29.043 39.342 26.8 88.514c-5.195 2.44-8.8 7.71-8.8 13.809v30.618c0 8.483 6.909 15.346 15.407 15.346z" />
			</g>
		</svg>
	)
}
